import React, { useContext } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import classes from './HeaderLogo.module.scss';
import { AccountContext } from '@/context/account.context';
import { SolutionContext } from '@/context/solution.context';

export default function HeaderLogo({ t, version }) {
  const account = useContext(AccountContext);
  const { solution, host } = useContext(SolutionContext);
  const { isLoggedIn } = account;

  const logo = {
    desktop: solution?.ui?.desktop?.logo,
    mobile: solution?.ui?.mobile?.logo
  };
  const hideMobileLogoBreakpoint = logo.mobile?.hide_at || 'xl';
  const homeLink = account.data?.is_professional ? '/dashboard' : isLoggedIn ? '/home' : '/';
  const HomeLink = ({ className, children }) =>
    homeLink === '/' ? (
      <a href="/" target="_self" className={className}>
        {children}
      </a>
    ) : (
      <Link href={homeLink} className={className}>
        {children}
      </Link>
    );

  if (!logo.desktop) return null; // config error, no logo

  if (version === 'mobile/tablet') {
    return (
      <HomeLink className="logoImgLink mobile">
        <Image
          src={logo.desktop.src}
          className={`${classes.logoImg} pt-0 logoImg`}
          width={logo.desktop.width}
          height={logo.desktop.height}
          alt={t(logo.desktop.alt)}
          data-solution={host}
        />
      </HomeLink>
    );
  }
  return (
    <>
      <div className={`d-none d-${hideMobileLogoBreakpoint}-flex me-2 ${classes.left}`}>
        <HomeLink className="logoImgLink">
          <Image
            src={logo.desktop.src}
            width={logo.desktop.width}
            height={logo.desktop.height}
            className={`${classes.logoImg} logoImg`}
            alt={t(logo.desktop.alt)}
            data-solution={host}
          />
        </HomeLink>
      </div>
      {logo.mobile && (
        <div className={`${classes.mobileLogo} d-${hideMobileLogoBreakpoint}-none logoImgLink`}>
          <HomeLink>
            <Image
              src={logo.mobile.src}
              width={logo.mobile.width}
              height={logo.mobile.height}
              alt={t(logo.mobile.alt)}
              data-solution={host}
              className={`logoImg${logo.mobile.class_name ? ` ${classes[logo.mobile.class_name]}` : ''}`}
            />
          </HomeLink>
        </div>
      )}
    </>
  );
}
